export enum IndividualMultiplierState {
  Open = 'Open',
  Edited = 'Edited',
  Finalized = 'Finalized',
  AutoFinalized = 'AutoFinalized',
  AutoFinalizedOpen = 'AutoFinalizedOpen'
}
